import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import { UserResponse } from "api";
import { useLocaleContext } from "lang";

import { setUserData } from "./app/appSlice";
import type { RootState, AppDispatch } from "./store";

export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();

export const useHandleUserResponse = () => {
  const dispatch = useAppDispatch();
  const { syncLocale } = useLocaleContext();

  return useCallback(
    (data: UserResponse) => {
      dispatch(setUserData(data));
      if (data.user.locale) syncLocale(data.user.locale);
    },
    [dispatch, syncLocale],
  );
};
